// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'work-sans-bold';
  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-Bold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'work-sans-extrabold';
  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-ExtraBold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'work-sans-semibold';
  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-SemiBold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'work-sans-medium';
  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-Medium.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'work-sans-regular';
  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'work-sans-light';
  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-Light.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}
html {
  font-family: sans-serif;
  font-size: 10px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  font-size: 1.6rem;
  line-height: 1.5;
  color: #334960;
  background-color: #ffffff;
  overflow-x: hidden;
  height: 100%;
}

h1 {
  font-size: 3.2rem;
  font-weight: 600;
  line-height: 150%;
}

h2 {
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 150%;
}

h3 {
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 150%;
}

h1,
h2 {
  color: #000000;
  font-family: 'work-sans-semibold', sans-serif;
}
h3,
h4 {
  color: #000000;
  font-family: 'work-sans-medium', sans-serif;
}
h1,
h2,
h3,
h4,
h5 {
  margin: 0 0 1.1rem;
}

p,
span {
  color: #000000;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 150%;
  font-family: 'work-sans-regular', sans-serif;
}

label {
  font-size: 1.2rem;
  font-weight: 500;
  color: #1f2937;
  display: flex;
  gap: 2px;
}
input,
select {
  background: #ffffff;
  border: 1px solid #d7d2fc;
  box-shadow: 0px 1px 4px 0px #00000005;
  padding: 1rem 1.2rem;
  outline: none;
  border-radius: 8px;
}

input::placeholder {
  font-size: 1.3rem;
  font-weight: 400;
  color: #707070;
  opacity: 0.5;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden],
template {
  display: none;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

mark {
  background: #ff0;
  color: #000;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

svg:not(:root) {
  overflow: hidden;
}

hr {
  box-sizing: content-box;
  height: 0;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #eeeeee;
}

pre {
  overflow: auto;
}
::-webkit-scrollbar {
  width: 10px;
}
/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}

button,
select {
  text-transform: none;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

input {
  line-height: normal;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

input[type="search"] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
}

input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
}

optgroup {
  font-weight: bold;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

* {
  box-sizing: border-box;
}

*:before,
*:after {
  box-sizing: border-box;
}

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: 1.3rem;
  line-height: inherit;
}

ul {
  margin: 0;
  padding: 0;
}

ul li {
  display: block;
}

a {
  text-decoration: none;
  font-family: 'work-sans-medium', sans-serif;
  font-weight: 400;
}

a:hover,
a:focus,
a:active {
  text-decoration: none;
  outline: none;
}

figure {
  margin: 0;
}

img {
  vertical-align: middle;
  max-width: 100%;
}

@media (max-width: 1024px) {
  html {
    font-size: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/global/primary.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,uHAAuH;EACvH,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,4HAA4H;EAC5H,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,2HAA2H;EAC3H,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,yHAAyH;EACzH,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,0HAA0H;EAC1H,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,wHAAwH;EACxH,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,6CAA6C;AAC/C;AACA;;EAEE,cAAc;EACd,2CAA2C;AAC7C;AACA;;;;;EAKE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,QAAQ;AACV;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;;;;;;;;;;;;;EAaE,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA,UAAU;AACV;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA;;;;EAIE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAIE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAG7B,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;;EAIE,sBAAsB;AACxB;;AAEA;;;;EAIE,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["@font-face {\n  font-family: 'work-sans-bold';\n  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-Bold.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'work-sans-extrabold';\n  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-ExtraBold.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'work-sans-semibold';\n  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-SemiBold.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'work-sans-medium';\n  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-Medium.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'work-sans-regular';\n  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'work-sans-light';\n  src: url('https://8162471.fs1.hubspotusercontent-na1.net/hubfs/8162471/work-sans/WorkSans-Light.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  text-decoration: none;\n}\nhtml {\n  font-family: sans-serif;\n  font-size: 10px;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nbody {\n  font-size: 1.6rem;\n  line-height: 1.5;\n  color: #334960;\n  background-color: #ffffff;\n  overflow-x: hidden;\n  height: 100%;\n}\n\nh1 {\n  font-size: 3.2rem;\n  font-weight: 600;\n  line-height: 150%;\n}\n\nh2 {\n  font-size: 1.8rem;\n  font-weight: 600;\n  line-height: 150%;\n}\n\nh3 {\n  font-size: 2.4rem;\n  font-weight: 700;\n  line-height: 150%;\n}\n\nh1,\nh2 {\n  color: #000000;\n  font-family: 'work-sans-semibold', sans-serif;\n}\nh3,\nh4 {\n  color: #000000;\n  font-family: 'work-sans-medium', sans-serif;\n}\nh1,\nh2,\nh3,\nh4,\nh5 {\n  margin: 0 0 1.1rem;\n}\n\np,\nspan {\n  color: #000000;\n  font-weight: 400;\n  font-size: 1.6rem;\n  line-height: 150%;\n  font-family: 'work-sans-regular', sans-serif;\n}\n\nlabel {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #1f2937;\n  display: flex;\n  gap: 2px;\n}\ninput,\nselect {\n  background: #ffffff;\n  border: 1px solid #d7d2fc;\n  box-shadow: 0px 1px 4px 0px #00000005;\n  padding: 1rem 1.2rem;\n  outline: none;\n  border-radius: 8px;\n}\n\ninput::placeholder {\n  font-size: 1.3rem;\n  font-weight: 400;\n  color: #707070;\n  opacity: 0.5;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline;\n}\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n[hidden],\ntemplate {\n  display: none;\n}\n\nb,\nstrong {\n  font-weight: bold;\n}\n\ndfn {\n  font-style: italic;\n}\n\nmark {\n  background: #ff0;\n  color: #000;\n}\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\nhr {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  height: 0;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #eeeeee;\n}\n\npre {\n  overflow: auto;\n}\n::-webkit-scrollbar {\n  width: 10px;\n}\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 5px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 5px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #ccc;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\ninput {\n  line-height: normal;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  padding: 0;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\nlegend {\n  border: 0;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n}\n\noptgroup {\n  font-weight: bold;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ntd,\nth {\n  padding: 0;\n}\n\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: 1.3rem;\n  line-height: inherit;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n}\n\nul li {\n  display: block;\n}\n\na {\n  text-decoration: none;\n  font-family: 'work-sans-medium', sans-serif;\n  font-weight: 400;\n}\n\na:hover,\na:focus,\na:active {\n  text-decoration: none;\n  outline: none;\n}\n\nfigure {\n  margin: 0;\n}\n\nimg {\n  vertical-align: middle;\n  max-width: 100%;\n}\n\n@media (max-width: 1024px) {\n  html {\n    font-size: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
